//Importaciones
import React, { useContext, useState } from 'react'
import { Card, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { ActionButton, Checkbox } from '@fluentui/react';
import { isNullUndefined, showMessage } from '../../../../../../common/Helpers';
import MessageBoxInfoComplex from '../../../../../Common/Message/MessageBoxInfoComplex';
import { __MessageTypes } from '../../../../../../common/Dictionaries';
import { __OBJECT_STRUCTURE_BoardFilters } from '../../../../../../common/ObjectStructures/sKPI';
import { useDispatch, useSelector } from 'react-redux';
import MainAppContext from '../../../../../../MainAppContext';
import { action_setDefaultSelectedFiltersBinded, action_setExternalHome_FireGetData, action_setExternalHome_SelectedContract } from '../../../../../../reducers/actions/SITE/externalHomeActions';
import { useSearch } from '../../../../../../hooks/component/useOfExternalHome';
import { __onGoToObligationControl } from '../../../../../../common/SystemRedirections';
import Loading from '../../../../../Templates/Site/Loading';


function ELEMENT_CONTRACT_HOME_EXTERNAL(props) {
    //Helpers
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const contextSite = useContext(MainAppContext);
	const { _boardComponentInfoRecursiveValues: boardComponentInfoRecursiveValues } = useSelector((state) => state.boardViewComponentsScope);

    const { 
		inputParam_HideHeader = false,
		inputParam_ComponentContent = null,
		inputParam_ContainerComponent = null,
		inputParam_UseFake = false,
		inputParam_BoardId = null,
    } = props;

    const { 
		_selectedContract: selectedContract,
		_contratosBase: contratosBase,
		_defaultSelectedFiltersBinded: defaultSelectedFiltersBinded,
		_fireLoading: fireLoading,
	} = useSelector((state) => state.externalHomeScope);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const onChangeContract = (ev, isChecked, contract) => {
        let _aux_selectedContract = {...selectedContract}
        dispatch(action_setExternalHome_FireGetData(true))
		
        if (isChecked) {
			_aux_selectedContract = contract
			dispatch(action_setExternalHome_SelectedContract(_aux_selectedContract))
        }
        else {
            _aux_selectedContract = null;
            dispatch(action_setExternalHome_SelectedContract(_aux_selectedContract))
        }

		dispatch(action_setDefaultSelectedFiltersBinded(false));
    }

    const renderContent = () => {
		return  <Row className='px-3'>
					<div style={{maxHeight: "200px"}}>
						{
							(inputParam_ComponentContent && contratosBase).map(contract => (
								<Checkbox
									key={contract.id}
									label={`${contract.contractCode} - ${contract.supplierName}`}
									className='my-2'
									checked={!isNullUndefined(selectedContract) ? selectedContract.id === contract.id : false}
									onChange={(ev, checked) => onChangeContract(ev, checked, contract)}
								/>
							))
						}
					</div>
				</Row>
    }

	useSearch(defaultSelectedFiltersBinded, contextSite, selectedContract, inputParam_BoardId, boardComponentInfoRecursiveValues, inputParam_ContainerComponent.htmlOnclick)

    //Render de componente.
    return (
		<>
			{
			!inputParam_UseFake &&
			<Card className='h-100'>
				{
				!inputParam_HideHeader &&
				<>
					<Card.Header className="card-header-compact">
						<Card.Title className="d-flex justify-content-between">
						<b>{(!inputParam_UseFake && inputParam_ComponentContent !== null) ? (inputParam_ComponentContent.boardComponentTitle ?? t('data-lang-boxname-externalkpilist')) : t('data-lang-boxname-externalkpilist')}</b>
						<div className='toolbar d-flex'>
							<ActionButton iconProps={{iconName: "Trackers"}} text={t('data-lang-lbl-co-long')} onClick={() => __onGoToObligationControl()} />
						</div>
						</Card.Title>
					</Card.Header>
					{
						messageConfig.showMessage &&
						<Card.Footer>
							<MessageBoxInfoComplex
								inputParam_Message={ messageConfig.message }
								inputParam_Display={ messageConfig.showMessage }
								inputParam_MessageType={ messageConfig.messageType }
								inputParam_SetterMessage={ setMessageConfig }
								inputParam_ShowClose={true}
								inputParam_TranslateText={true}
							/>
						</Card.Footer>
					}
				</>
				}
				<Card.Body className='p-0 m-0' style={{overflowY: "scroll", overflowX: "hidden"}}>
				{
					fireLoading === false &&
					renderContent()
				}
				{
					fireLoading === true &&
					<Loading
						inputParam_Style={{marginTop: 100}}
						inputParam_Width = '30px'
						inputParam_Height = '30px'
					/>
				}
				</Card.Body>
			</Card>
			}
			{ inputParam_UseFake && renderContent() }
		</>
    );
}

ELEMENT_CONTRACT_HOME_EXTERNAL.propTypes = {
	inputParam_HideHeader: PropTypes.bool.isRequired,
	inputParam_ComponentContent: PropTypes.object.isRequired,
};

export default ELEMENT_CONTRACT_HOME_EXTERNAL;